import API from "../../services/api";
import router from "@/router/router";
import moment from "moment";
export default {
    state: {
        agents: [],
        filteredAgents: {},
        agent: {},
        agentCats: [],
        agentMoneys: [],
        agentMoney: {},
        filteredAgentMoneys: [],
        countAgentMoneys: [],
    },

    mutations: {


        setAgents: (state, agents) => {
            state.agents = agents;
            state.filteredAgents = agents;
        },

        filteredAgents: (state, agents) => {
            state.filteredAgents = agents;
        },

        setAgent: (state, agent) => {
            state.agent = agent;
        },

        setAgentCats: (state, agentCats) => {
            state.agentCats = agentCats;
        },

        setCategories: (state, categories) => {
            state.agentCategories = categories;
        },
        setAgentMoneys:  (state, agentMoneys) => {
            state.agentMoneys = agentMoneys
            state.filteredAgentMoneys = agentMoneys;
            state.countAgentMoneys = agentMoneys;
        },
        setAgentMoney:  (state, agentMoney) => {
            state.agentMoney = agentMoney
        }
    },

    actions: {
        addNewAgent(ctx, data) {
            console.log(data);

            var formData = new FormData();
            formData.append("email", data.email);
            formData.append("username", data.username);
            formData.append("name", data.name);
            formData.append("secondname", data.secondname);
            formData.append("middlename", data.middlename);
            formData.append("phone", data.phone);
            formData.append("studio_id", 10);
            formData.append("role", 7);
            API.POST("worker/create", formData).then((res) => {
                res.data.alert ? ctx.commit("setAlert", res.data.alert) : null;
            });
        },


        getAgents(ctx) {
            API.GET("worker/agents").then((res) => {
                localStorage.setItem("agents", JSON.stringify(res.data.agents));
                ctx.commit("setAgents", res.data.agents);

                // ctx.dispatch("loadSettings").then(() => {
                //     ctx.dispatch("findWorker", ctx.rootState.s);
                // });
            });
        },

        findAgent(ctx, s) {
            let list = ctx.state.agents;

            if (s.findme != "" && s.findme != undefined) {
                list = list.filter((item) => item.fullname.toLowerCase().indexOf(s.findme) !== -1);
            }         

            if (s.category != "" && s.category != undefined) {
                list = list.filter((item) => String(item.category_id) == String(s.category));
            }

            if (list.length != ctx.state.agents.length) {
                s.clear = true;
            }

            ctx.state.filteredAgents = list;
            ctx.dispatch("setSettings", s);
        },

        getAgent(ctx) {
            let agent = localStorage.getItem("agent");
            if (agent) {
                agent = JSON.parse(agent);
                ctx.commit("setAgent", agent);
                API.GET("worker/one-agent", { uid: ctx.state.agent.uid }).then((res) => {
                    localStorage.setItem("agent", JSON.stringify(res.data.agent));
                    ctx.commit("setAgent", res.data.agent);
                    ctx.commit("setAgentCats", res.data.cats);
                });
            } else {
                router.push("/agent");
            }
        },

        getAgentMoneys(ctx) {
            API.GET("finance/bid-moneys").then((res) => {
                ctx.commit("setAgentMoneys", res.data.bidMoneys);
                console.log('res.data.bidMoneys', res.data.bidMoneys)
                ctx.dispatch("loadSettings").then(() => {
                    ctx.dispatch("findAgentMoney", ctx.rootState.s);
                });
            });
        },

        findAgentMoney(ctx, s) {
            let list = ctx.state.agentMoneys;
            console.log('ctx.state.agentMoneys', ctx.state.agentMoneys)
            console.log(list)

            if (s.findme != "" && s.findme != undefined) {
                list = list.filter((item) => {
                    let codebill = null;
                    let client = null;

                    if (item.codebill) {
                        codebill = item.codebill.toLowerCase().indexOf(s.findme.toLowerCase()) !== -1;
                    }
                    if (item.client_full) {
                        client = item.client_full.toLowerCase().indexOf(s.findme.toLowerCase()) !== -1;
                    }
                    return (client || codebill);
                });
            }

            if ( s.status != undefined) {
                list = list.filter((item) => item.agent_status == s.status);
            }

            if (list.length != ctx.state.agentMoney.length) {
                s.clear = true;
            }

            ctx.state.filteredAgentMoneys = list;
            console.log(list)
            ctx.dispatch("setSettings", s);
        },
        showAgentMoney(ctx, agent) {
            ctx.commit("setAgentMoney", agent);
            // API.GET("ajax/comments", { params: { iid: money.iid } }).then((res) => {
            //     this.comments = res.data.comments;
            // });
        },

        changeAgent(ctx, agent) {
            console.log(agent);
            let formData = new FormData();
            formData.append("uid", agent.uid);
            formData.append("email", agent.email);
            formData.append("phone", agent.phone);
            API.POST("agent/change", formData).then((res) => {                
                localStorage.setItem("agent", JSON.stringify(res.data.agent));
                ctx.commit("setAgent", res.data.agent);
                ctx.commit("setAgentCats", res.data.cats);
                res.data.alert ? ctx.commit("setAlert", res.data.alert) : null;
            });
        },

        // changeWorker(ctx, worker){
        //     console.log('worker', worker);
        //     return API.POST("worker/change", { uid: worker.uid, worker: worker.email, phone: worker.phone, }).then((res) => {
        //         localStorage.setItem("worker", JSON.stringify(res.data.worker));
        //         ctx.commit("setWorker", res.data.worker);
        //         ctx.commit("setWorkerCats", res.data.cats);
        //     });
        // },

        getAgentById(ctx, id){
            console.log("id", id);
            return API.GET("agent/one-agent", { uid: id }).then((res) => {
                localStorage.setItem("agent", JSON.stringify(res.data.agent));
                ctx.commit("setAgent", res.data.agent);
                ctx.commit("setAgentCats", res.data.cats);
            });
        },

        addAgent(ctx) {
            API.GET("agent/add-agent").then((res) => {
                ctx.state.agents.push(res.data.worker);
                ctx.dispatch("setAgents", ctx.state.agents);
                ctx.dispatch("showAgent", res.data.agent);
            });
        },

        setAgent(ctx, agent) {
            localStorage.setItem("agent", JSON.stringify(agent));
            ctx.commit("setAgent", agent);
        },

        showAgent(ctx, agent) {
            ctx.dispatch("setAgent", agent);
            router.push("/agent/view");
        },

        delAgent(ctx, agent){
            // console.log("DEL", ctx, worker);
            let formData = new FormData();
            formData.append("uid", agent.uid);
            formData.append("active", agent.active);

            API.POST("worker/sack-agent", formData).then((res) => {
                if (res.data.agent) {
                    ctx.dispatch("setAgent", res.data.agent); 
                    res.data.alert ? ctx.commit("setAlert", res.data.alert) : null;

                    if (ctx.state.agent.uid == ctx.rootState.profile.profile.uid) {
                        ctx.dispatch("getProfile");
                    }
                }
            });
        },

        // onOffRole(ctx, role) {
        //     console.log("onOffRole", role);
        //     let formData = new FormData();
        //     formData.append("uid", ctx.state.agent.uid);
        //     formData.append("role", role);
        //     API.POST("agent/on-off-role", formData).then((res) => {
        //         if (res.data.agent) {
        //             ctx.dispatch("setAgent", res.data.agent);
        //             if (ctx.state.agent.uid == ctx.rootState.profile.profile.uid) {
        //                 ctx.dispatch("getProfile");
        //             }
        //         }
        //     });
        // },

        ChangeCat(ctx, cat) {
            let formData = new FormData();
            formData.append("uid", ctx.state.agent.uid);
            formData.append("cat", cat);
            API.POST("agent/change-cat", formData).then((res) => {
                ctx.commit("setAgentCats", res.data.cats);
            });
        },
        async doneAgentMoney(ctx, status) {
            console.log("doneAgentMoney");
            ctx.state.agentMoney.agent_status = status;
            ctx.dispatch("setAgentMoney", ctx.state.agentMoney);

            let formData = new FormData();
            formData.append("bid_id", ctx.state.agentMoney.id);
            formData.append("agent_status", status);
            formData.append("agent_date", moment(ctx.state.agentMoney.agent_date).format("YYYY-MM-DD HH:mm:ss"));
            await API.POST("finance/bid-done", formData);
            ctx.dispatch("getAgentMoneys");
        },        
    },

    getters: {
        AgentList(state) {
            return state.filteredAgents;
        },
        agent(state) {
            return state.agent;
        },
        agentCats(state) {
            return state.agentCats;
        },
        filteredAgentMoneys(state){
            return state.filteredAgentMoneys
        },
        agentMoneys(state){
            return state.agentMoneys
        },
        agentMoney(state){
            return state.agentMoney
        },
        agentMoneyList(state) {
            // state.filteredMoneys = state.filteredMoneys.filter((item) => parseInt(item.status) != 8);
            return state.filteredAgentMoneys;
        },
        agentMoneyCounter(state) {
            let count = [];
            if (state.countAgentMoneys.length > 0) {
                count[0] = 0;
                count[2] = 0;
                state.countAgentMoneys.forEach((elem) => {
                    if (elem.agent_status == 0) {
                        count[0]++;
                    } else {
                        count[2]++;
                    }
                });
            }
            return count;
        },
    },
};
